// extracted by mini-css-extract-plugin
module.exports = {"header":"MissionRedDot_header__1ZiB_","text":"MissionRedDot_text__3HDF2","image":"MissionRedDot_image__13Ib5","videobackground":"MissionRedDot_videobackground__18lc8"};